import { React, useState } from "react"

import ForgetPassword from "./forget-password"
import PopupSignup from "./popup-signup"
import PopupLoginTemplate from "../popup/popup-login-template"
import PopupSiginTemplate from "../popup/popup-sigin-template"

function LoginLink() {
  const [buttonPopupForget, setButtonPopupForget] = useState(false)
  const [buttonPopupSigin, setButtonPopupSigin] = useState(false)
  
  const handleSignupClick = (e) => {
    e.preventDefault();
    const redirectUrl = `${process.env.REACT_APP_SSO_URL}/?clientId=${process.env.REACT_APP_SSO_CLIENT_ID}&action=signup`;
    window.location.href = redirectUrl;
  };
  
  return (
    <ul className="login_tab d-flex align-items-center justify-content-end">
      <PopupLoginTemplate
        trigger={buttonPopupForget}
        setTrigger={setButtonPopupForget}
      >
        <ForgetPassword onOk={() => setButtonPopupForget(false)} />
      </PopupLoginTemplate>
      <PopupSiginTemplate
        trigger={buttonPopupSigin}
        setTrigger={setButtonPopupSigin}
      >
        <PopupSignup />
      </PopupSiginTemplate>
      <li onClick={() => setButtonPopupForget(true)}>忘記密碼</li>
      <li onClick={handleSignupClick}>尚未註冊</li>
    </ul>
  )
}

export default LoginLink
